/**
 * Disciplíny závodů.
 *
 * Od sezóny 2027 se jezdí kulovnice i malorážka a každá má vlastní celkové
 * hodnocení — včetně vlastního počtu nejlepších závodů. Závod proto nese pole
 * `discipline`; starší závody ho nemají a berou se jako kulovnice, aby
 * historická hodnocení zůstala beze změny.
 *
 * Přidání další disciplíny = jedna položka v DISCIPLINES, nikde jinde se
 * nic měnit nemusí (formulář, štítky i filtry se generují odsud).
 */

export type DisciplineId = "KULOVNICE" | "MALORAZKA";

export interface Discipline {
  id: DisciplineId;
  /** Plný název – formulář, filtry, hlavičky výsledků */
  label: string;
  /** Zkratka do úzkých míst (mobilní štítky, tabulky) */
  short: string;
  /** Barva štítku – stejná napříč celou aplikací, ať je disciplína poznat na první pohled */
  color: string;
  /** Světlé pozadí pod barvu textu */
  bg: string;
}

export const DISCIPLINES: Record<DisciplineId, Discipline> = {
  KULOVNICE: {
    id: "KULOVNICE",
    label: "Kulovnice",
    short: "K",
    // Lesní zelená – myslivecká paleta, ladí s brandem (modrá k lovu nesedí)
    color: "#1b5e20",
    bg: "#e8f2e7",
  },
  MALORAZKA: {
    id: "MALORAZKA",
    label: "Malorážka",
    short: "M",
    // Měděná – barva střely .22, odlišná od admin oranžové i warning
    color: "#7a4a12",
    bg: "#f4ead9",
  },
};

/** Závody bez pole discipline (vše do sezóny 2026) jsou kulovnice. */
export const DEFAULT_DISCIPLINE: DisciplineId = "KULOVNICE";

export const DISCIPLINE_LIST: Discipline[] = Object.values(DISCIPLINES);

/** Bezpečný převod čehokoli z databáze na známou disciplínu. */
export function toDisciplineId(value: unknown): DisciplineId {
  const key = String(value ?? "").toUpperCase();
  return key in DISCIPLINES ? (key as DisciplineId) : DEFAULT_DISCIPLINE;
}

/** Disciplína závodu i pro starší záznamy bez pole. */
export function disciplineOf(race: { discipline?: string | null } | null | undefined): Discipline {
  return DISCIPLINES[toDisciplineId(race?.discipline)];
}
